import * as React from 'react';

import {Radio} from 'antd';

import {Redirect, useHistory} from 'react-router-dom';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';

import {DotLocation, Question, Session} from '@app/components/Pages/QualityOfLife/QualityOfLifeAssessment';
import {Strike} from '@app/components/UI/Strike/Strike';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

import '@app/scss/components/QOLQuestionary.scss';

import dogBodyImg from '@app/content/qualityOfLife/dog_body.svg';
import dogHeadImg from '@app/content/qualityOfLife/dog_head.svg';
import dogBackImg from '@app/content/qualityOfLife/dog_back.svg';
import dogBackLegsImg from '@app/content/qualityOfLife/dog_backLegs.svg';
import dogBellyImg from '@app/content/qualityOfLife/dog_belly.svg';
import dogHeadFrontImg from '@app/content/qualityOfLife/dog_headfront.svg';
import dogLegsImg from '@app/content/qualityOfLife/dog_legs.svg';
import catBodyImg from '@app/content/qualityOfLife/cat_body.svg';
import catHeadImg from '@app/content/qualityOfLife/cat_head.svg';
import catBackImg from '@app/content/qualityOfLife/cat_back.svg';
import catBackLegsImg from '@app/content/qualityOfLife/cat_backLegs.svg';
import catBellyImg from '@app/content/qualityOfLife/cat_belly.svg';
import catHeadFrontImg from '@app/content/qualityOfLife/cat_headfront.svg';
import catLegsImg from '@app/content/qualityOfLife/cat_legs.svg';

const QOLQuestionary = (props) => {
	const countOptions = 3;

	const [answer, setAnswer] = React.useState(-1);
	const [answerList, setAnswerList] = React.useState<number[]>([]);
	const [currentQuestion, setCurrentQuestion] = React.useState(0);

	const [state, setState] = React.useState<Session>({...props.location.state});
	const history = useHistory();
	const [isMobile, setIsMobile] = React.useState(false);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	const initState = () => {
		setState(props.location.state);
		localStorage.setItem('questionState', JSON.stringify(props.location.state));
	};

	const retrieveState = () => {
		const retrievedState = localStorage.getItem('questionState');
		retrievedState && setState(JSON.parse(retrievedState));
		history.push('/quality-of-life-assessment/question/0');
	};

	React.useEffect(() => {
		props.location.state ? initState() : retrieveState();
	}, []);

	React.useEffect(() => {
		state.questions && currentQuestion + 1 <= state.questions.length &&
		history.push(`/quality-of-life-assessment/question/${currentQuestion}`);
	}, [currentQuestion]);

	const handleChange = (e) => {
		setAnswer(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (answer > -1) {
			setAnswerList([...answerList, answer]);
			setCurrentQuestion(currentQuestion + 1);
			setAnswer(-1);
		}
	};

	const prevQuestion = (e) => {
		e.preventDefault();
		setAnswer(answerList[answerList.length - 1]);
		answerList.splice(-1, 1);
		setAnswerList(answerList);
		setCurrentQuestion(currentQuestion - 1);
	};

	const getImage = (petType: string, questionNumber: number) => {
		const isDog = state.petType === 'dog';
		const question = state.questions[questionNumber] as Question;

		switch (question.dotLocation) {
			case DotLocation.Head:
				return isDog ? dogHeadImg : catHeadImg;
			case DotLocation.HeadFront:
				return isDog ? dogHeadFrontImg : catHeadFrontImg;
			case DotLocation.Body:
				return isDog ? dogBodyImg : catBodyImg;
			case DotLocation.Legs:
				return isDog ? dogLegsImg : catLegsImg;
			case DotLocation.BackLegs:
				return isDog ? dogBackLegsImg : catBackLegsImg;
			case DotLocation.Belly:
				return isDog ? dogBellyImg : catBellyImg;
			case DotLocation.Back:
				return isDog ? dogBackImg : catBackImg;
		}

		return isDog ? dogHeadImg : catHeadImg;
	};

	return(
		state?.questions ?
		(currentQuestion + 1 <= state.questions.length ?
		<div className="qol-qustionary__wrapper">
			<div className="qol-qustionary">
				<div className="qol-qustionary-body">
					<div className="qol-qustionary-body__img">
						<img src={getImage(state.petType, currentQuestion)} />
					</div>

					<h3>
						{state.questions && state.questions[props.match.params.id].text}
					</h3>
					<form
						onSubmit={handleSubmit}
					>
						<Radio.Group onChange={handleChange} value={answer}>
							<Radio value={0}>
								Agree
							</Radio>
							<Radio value={1}>
								Somewhat agree
							</Radio>
							<Radio value={2}>
								Disagree
							</Radio>
						</Radio.Group>
						<button type="submit" className={`btn btn-md btn-primary ${answer === -1 ? 'disabled' : ''}`}>Continue</button>
					</form>
				</div>
				<div className="qol-qustionary__footer">
					<LinkMore linkMoreCaption="Previous question" linkMoreLink="#" handleCLick={prevQuestion} linkBack={true} classNameAdd={currentQuestion < 1 ? 'disabled' : ''}/>
					<div className="qol-qustionary__footer-progress">
						<span>
							{state.questions && Math.floor(100 / state.questions.length * (currentQuestion))}% Complete
						</span>
						<Strike offset={100 / state.questions.length * (currentQuestion)}/>
						{isMobile &&
							<div className="qol-qustionary__footer-info">
								<div className="qol-qustionary__footer-category">{state.questions[props.match.params.id].category}</div>
								<div className="qol-qustionary__footer-count">Question {currentQuestion + 1}/{state.questions.length}</div>
							</div>
						}
					</div>
					{!isMobile && <div className="qol-qustionary__footer-info">
						<div className="qol-qustionary__footer-category">{state.questions[props.match.params.id].category}</div>
						<div className="qol-qustionary__footer-count"><span>Question {currentQuestion + 1}/{state.questions.length}</span></div>
					</div>}
				</div>
			</div>
		</div> :
				<Redirect to={{
					pathname: '/quality-of-life-assessment/results',
					state: {answerList: answerList, sessionId: state.sessionId, petType: state.petType, petName: state.petName}
				}}
				/>
		)
			:
			<div>Loading...</div>

	);
};

export default QOLQuestionary;